export default __webpack_public_path__ + "images/Stcourier_logo.svg";